import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const QTY_ASSETS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/qty-assets',
        iconClass: 'fas fa-cubes',
        name: 'RegisterService::QtyAssets',
        order: 17,
        layout: eLayoutType.application,
        requiredPolicy: 'RegisterService.Consumables.Page',
      },
    ]);
  };
}
